/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Heading_LabelInputs */

const ja_careers_heading_label = /** @type {(inputs: Careers_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join Us`)
};

const en_careers_heading_label = /** @type {(inputs: Careers_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join Us`)
};

/**
* | output |
* | --- |
* | "Join Us" |
*
* @param {Careers_Heading_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const careers_heading_label = /** @type {((inputs?: Careers_Heading_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Heading_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_heading_label(inputs)
	return en_careers_heading_label(inputs)
});